<div class="dialog-actions">
    <ng-content></ng-content>
</div>